.header {
    margin-bottom: 10px;
    text-align: left;
}
